var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrums = function SvgDrums(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.75 12.824a.75.75 0 0 0-1.5 0zm-1.5 0v8.94h1.5v-8.94zM21.28 11.882a.75.75 0 1 0-1.5 0zm-1.5 0v8.942h1.5v-8.942zM6.22 11.882a.75.75 0 0 0-1.5 0zm-1.5 0v8.942h1.5v-8.942z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.588 11.784c.457-.41.706-.852.706-1.313q-.002-.363-.198-.706h.198c.39 0 .706.316.706.706V18c0 .829-.504 1.506-1.156 2.02-.66.52-1.572.957-2.635 1.312-2.133.71-5.035 1.139-8.209 1.139s-6.076-.428-8.21-1.14c-1.062-.354-1.974-.791-2.633-1.311C1.505 19.506 1 18.829 1 18v-7.53c0-.39.316-.705.706-.705h.198q-.196.343-.198.706c0 .461.25.904.706 1.313V18c0 .21.127.524.618.911.483.38 1.226.755 2.207 1.081 1.954.652 4.699 1.067 7.763 1.067s5.809-.415 7.763-1.067c.98-.326 1.724-.7 2.207-1.081.49-.387.618-.7.618-.911z",
    clipRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 10.471,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    rx: 11.294,
    ry: 3.765
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M24.294 2 9.706 10.47"
  })));
};
export default SvgDrums;